// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1jrQA","overflowing":"ReadFullNote_overflowing__VPc4Y"};